export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const HEADERS = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
};
